import { render } from "./verifyotp.vue?vue&type=template&id=636f44e5&scoped=true"
import script from "./verifyotp.vue?vue&type=script&lang=js"
export * from "./verifyotp.vue?vue&type=script&lang=js"

import "./verifyotp.vue?vue&type=style&index=0&id=636f44e5&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GCTUSMS\\codev1\\apply_online\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636f44e5"]])

export default __exports__